import { render, staticRenderFns } from "./CarouselScrollSelectPlugType.vue?vue&type=template&id=7e8bf3cf"
import script from "./CarouselScrollSelectPlugType.vue?vue&type=script&lang=js"
export * from "./CarouselScrollSelectPlugType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports